export default function authHeader() {
    const authCustomer = JSON.parse(localStorage.getItem('authCustomer'));

    if (authCustomer) {
        return { Authorization: 'Bearer ' + authCustomer.token };
    } else {
        return {};
    }
}